var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSymbol(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.30663 3.8176C3.52716 2.63076 4.32379 1 5.68303 1H16.3199C17.2478 1 18 1.80172 18 2.7907V6.88372C18 7.30757 17.6776 7.65116 17.28 7.65116C16.8823 7.65116 16.5599 7.30757 16.5599 6.88372V2.7907C16.5599 2.64942 16.4524 2.53488 16.3199 2.53488H5.68303C5.48885 2.53488 5.37505 2.76785 5.4864 2.9374L10.764 10.9731C11.169 11.5897 11.169 12.4103 10.764 13.0269L5.4864 21.0626C5.37505 21.2322 5.48885 21.4651 5.68303 21.4651H16.3199C16.4524 21.4651 16.5599 21.3506 16.5599 21.2093V17.1163C16.5599 16.6924 16.8823 16.3488 17.28 16.3488C17.6776 16.3488 18 16.6924 18 17.1163V21.2093C18 22.1983 17.2478 23 16.3199 23H5.68303C4.32379 23 3.52716 21.3692 4.30663 20.1824L9.58424 12.1467C9.64209 12.0586 9.64209 11.9414 9.58424 11.8533L4.30663 3.8176Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSymbol);
export default __webpack_public_path__ + "static/media/symbol.d8fb2e9777d0adfb737e6f9d16342ad5.svg";
export { ForwardRef as ReactComponent };